import React from 'react';
import Helmet from 'react-helmet';
import MainMenu from '@/Shared/MainMenu';
import FlashMessages from '@/Shared/FlashMessages';
// import TopHeader from '@/Shared/TopHeader';
import Container from 'react-bootstrap/Container';
import { APP_NAME } from '@/constants/Site';
import CommonHeader from '@/Shared/Layouts/Headers/CommonNavbar'
import TopPublicHeader from '@/Shared/Layouts/Headers/TopPublicHeader';
import BottomGeneralFooter from '@/Shared/Layouts/Footers/BottomGeneralFooter';
import NavsFooter from '@/Shared/Layouts/Footers/NavsFooter';
import { usePage } from '@inertiajs/inertia-react';
import {useProps} from '@/Shared/FuncComp'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import {whatsappUrlMessage} from '@/utils'
import LateralSocial from '@/Shared/Layouts/Menus/LateralSocial';

export default function MainLayout({ children }) {
	const {title, metaTags, url} = useProps();
	// const goWhatsapp = whatsappUrlMessage("¡Hola!");
	const extraMetaTags = [];
	return (<div id="inner-app">
		<Helmet titleTemplate={"%s | "+APP_NAME} title={title}>
			<meta name='apple-mobile-web-app-title' content={title} />
			<meta name='twitter:title' content={title} />
			<meta property='og:title' content={title} />
			<meta name='twitter:url' content={url} />
			<meta property='og:url' content={url} />
			{metaTags && metaTags.map((meta, idx)=>{
				const tag = <meta {...meta} key={'meta-tag-'+idx} />
				if (meta.name) {
					switch (meta.name) {
						case 'description':
							extraMetaTags.push(<meta name='twitter:description' content={meta.content} key="twitter:description-extra" />)
							extraMetaTags.push(<meta property='og:description' content={meta.content} key="og:description-extra" />)
							break;
					}
				}
				return tag;
			})}
			{extraMetaTags}
		</Helmet>
		<header className="bg-primary text-light text-reset-inner">
			<TopPublicHeader />
			<CommonHeader />
		</header>
		<main className="">
			<FlashMessages />
			{children}
		</main>
		<footer className="px-3 py-4 bg-primary text-white text-reset-inner">
			<NavsFooter />
			<Container><hr /></Container>
			<BottomGeneralFooter />
			{/* <div className="go-whatsapp-cnt show">
				<a href={goWhatsapp} target="_blank" className="go-whatsapp-btn">
					<FontAwesomeIcon className="go-whatsapp-icon" icon={faWhatsapp} />
				</a>
			</div> */}
		</footer>
		<LateralSocial />
	</div>
  );
}
